<template class="modal-copy-clipboard">
<b-modal id="copy-clipboard-modal" centered :hide-footer="true" :hide-header="true">
  <template>
    <p class="modal-title">URL Copied</p>
  </template>

  <div class="modal-text">
    <p
      ><b>{{ this.copiedLink }}</b> <br />has been copied to your clipboard! <br />Paste this URL anywhere you like.</p
    >
  </div>
</b-modal>
</template>

<script>
import { shareComputed } from '@state/helpers';

export default {
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {
    ...shareComputed,
  },
  methods: {},
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-title {
  font-size: 1.7rem;
  font-weight: 600 !important;
  margin-bottom: 2.4rem;
}

.modal-body {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.modal-text {
  font-weight: 400;
  text-align: center;
}
</style>
